import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';

class ProductEditStockLevel implements ng.IController {
    public static $inject = [];
    public variationId: string;
    public productId: string;
    public stockLevel: string;
    public waiting: boolean;
    public onSave: (message: any) => any;
    public onCancel: () => any;

    public save() {
        this.onSave({
            productId: this.productId,
            variationId: this.variationId,
            stockLevel: this.stockLevel != null ? parseInt(this.stockLevel, 10) : null
        });
    }

    public cancel() {
        this.onCancel();
    }
}

angular.module('naut').component('productEditStockLevel', {
    template: require('./edit-stock-level.component.html'),
    controller: ProductEditStockLevel,
    controllerAs: 'vm',
    bindings: {
        productId: '<',
        variationId: '<',
        stockLevel: '<',
        waiting: '<',
        onSave: '&',
        onCancel: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/modals/edit-stock-level/edit-stock-level.component.ts